import { render, staticRenderFns } from "./jindieextra.vue?vue&type=template&id=26628a89&scoped=true&"
import script from "./jindieextra.vue?vue&type=script&lang=js&"
export * from "./jindieextra.vue?vue&type=script&lang=js&"
import style0 from "./jindieextra.vue?vue&type=style&index=0&id=26628a89&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26628a89",
  null
  
)

export default component.exports